<script>
    import Modal from "../../components/modal.svelte";
    import MatchUsers from "./matchusers.svelte";
    import wrappedFetch from "../../../wrappedFetch.js";
    import DataTable from '../../../components/data-table.svelte';
    
    export let unmatchedUsers = [];
    export let selectedRoleType = "";
    export let onMatch = null;
    export let onAddTransfer = null;
    export let onCreate = null;
    export let onCancelPendingTransferRequest = null;
    let isPageLoading = false;
    let matchedUsers = [];    
    let selectedUser;
    export let showConfirmModal="";
    let showModal = false;
    let showResultModal = false;
    let resultMessage = "";
    let role =
        selectedRoleType == "S"
            ? "Staff"
            : selectedRoleType == "P"
            ? "Pupil"
            : "";
    let bid = 0;
    let isButtonLoading=false;    
    let isMatchLoading=[];
    let order = [[1, "asc"]];
    let resultModalHeading = "Info";

    const getPossibleMatches = async (user) => {
        if (user.role == "Staff") {
            let resp = await wrappedFetch(
                `/api/reports/GetPossibleMatchedStaff?staffId=${user.bulkProcessStaffID}`,
                { method: "post" }
            );
            matchedUsers = await resp.json();
        } else if (user.role == "Pupil") {
            let resp = await wrappedFetch(
                `/api/reports/GetPossibleMatchedPupil`,
                {
                    method: "post",
                    body: JSON.stringify(user),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            matchedUsers = await resp.json();
        }
        if (matchedUsers.length > 0)
            matchedUsers.forEach((u, i) => {
                u.addIdName = `addContent${i + 1}`;
                u.transferIdName = `transferContent${i + 1}`;
            });
    };

    const showMatchOptions = async (user) => {
        showResultModal = false;
        showModal = true;
        isPageLoading= true;
        selectedUser = user;
        bid = selectedRoleType == "P" ? selectedUser.bulkProcessPupilID : selectedRoleType == "S" ? selectedUser.bulkProcessStaffID : 0;
        await getPossibleMatches(user);
        isPageLoading = false;
    };

    const cancelRequest = async (user) => {
        resultMessage = "";
        let result = await onCancelPendingTransferRequest(user);
        resultMessage = result ? result.message : "";
        if (result && result.success) {
            showModal = false;
            showResultModal = true;
        }
    };
    const handleConfirm = async(e)=>{
        let actionType = e.detail.action;
        let matchedUser = e.detail.u;
        let i = e.detail.i;
        if(role=="Pupil")
        {
            if(actionType =="add")
            {
               await  pupilAddAndTransfer(matchedUser,"add");
            }
            else if(actionType=="transfer")
            {
               await pupilAddAndTransfer(matchedUser,"xfer");
            }

        }
        if(role=="Staff")
        {
            if(actionType =="add")
            {
                await staffRequestAddTransfer(matchedUser,'a');
            }
            else if(actionType=="transfer")
            {
                await staffRequestAddTransfer(matchedUser,'m');
            }
            else if(actionType=="match")
            {
                await matchStaff(matchedUser)
            }
        }
        isMatchLoading[i] = false;
        isMatchLoading =[...isMatchLoading];


    }
    const matchStaff=async(matchedUser)=>{
        let result = await onMatch(matchedUser,bid);        
        resultMessage = result ? result.message : "";
        resultModalHeading = result && result.success ?resultModalHeading :"Error"
        showModal = false;
        showResultModal = true;
    }

    const createNewUser = async () => {
        isButtonLoading = true;        
        showResultModal = false; 
        let result = await onCreate(bid);
        isButtonLoading = false;
        resultMessage = result ? result.message : "";
        if (result && result.success) {
            showModal = false;
            showResultModal = true;
        }
    };
  
    const pupilAddAndTransfer = async (user,type) => {
        resultMessage = "";        
        let result = await onAddTransfer(user,bid,type);        
        resultMessage = result ? result.message : "";
        if (result && result.success) {
            showModal = false;
            showResultModal = true;
        }
    };

    const staffRequestAddTransfer = async (matchedUser,type) => { 
        let result = await onAddTransfer(matchedUser,type,bid,selectedUser);
        if (result && result.success) {
            showModal = false;
            showConfirmModal = false;
            showResultModal = true;
            resultMessage = result.message;
        }        
    };

    let columnDefs = [{ type: 'date-euro', targets: [3] }, {orderable: false, targets: [4]}];
    // const getTableConfig = (dataSource)=>{  
    //     return  {data:dataSource,config: {"paging": false,"info": false,"searching": false, "order": [[0, "asc"]]}};        
    // }
    
    // let actionType = "";
    // const onHandleConfirm = async () => {
    //     if (actionType == "addStaff" || actionType == "transferStaff")
    //         await requestAddTransfer();
    // };


    function getSelectedUser(data){
        if (jQuery('div.dtr-bs-modal').length > 0){
            jQuery('.dtr-bs-modal').modal('hide');
        }
        if (data.substring(0,1) == "P")
            return unmatchedUsers.find(x => x.bulkProcessPupilID === (parseInt(data.substring(1))));
        else if (data.substring(0,1) == "S")
            return unmatchedUsers.find(x => x.bulkProcessStaffID === (parseInt(data.substring(1))));
    }
    
    document.addEventListener('click', function (event) {
        if (!event.target.matches('.MatchOptionsMobile')) return;
        showMatchOptions(getSelectedUser(event.target.getAttribute('data')));
    }, false);
    document.addEventListener('click', function (event) {
        if (!event.target.matches('.CancelOptionsMobile')) return;
        cancelRequest(getSelectedUser(event.target.getAttribute('data')));
    }, false);

    function showMatchOptionsMobile(event){
        if (event.detail.text == "TableUpdated"){
            jQuery(".table").on('click','.MatchOptionsMobile', function () { 
                showMatchOptions(getSelectedUser(jQuery(this).attr('data')));
            });

            jQuery(".table").on('click','.CancelOptionsMobile', function () { 
                cancelRequest(getSelectedUser(jQuery(this).attr('data')));
            });
        }
    }
</script>

<style>
    .tooltip_text {
        border: 1px solid #c4cdd5;
        position: absolute;
        background: whitesmoke;
        padding: 0.5rem;
        display: none;
    }

    .info:hover + .tooltip_text {
        display: block;
    }
    .info {
        color: #209cee;
        cursor: pointer;
    }
</style>
    <div class="row">
        <div class="col-12">
            <DataTable {columnDefs} DataLength={unmatchedUsers.length} {order} ResponsiveHeader='0,1' on:message={showMatchOptionsMobile}>
                <thead>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Gender</th>
                        <th>Date of Birth</th>
                        <th/>
                    </tr>
                </thead>
                <tbody>
                    {#each unmatchedUsers as user}
                        <tr>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>{user.gender}</td>
                            <td>{user.birth}</td>
                            <td>
                                {#if user.showPendingMessageCancel}
                                    <a
                                        class="CancelOptionsMobile btn btn-grey mt-1"
                                        href="#"
                                        data={selectedRoleType == "P" ? selectedRoleType + user.bulkProcessPupilID : selectedRoleType == "S" ? selectedRoleType + user.bulkProcessStaffID : 0}
                                        data-toggle="modal"
                                        data-target=".match-options"
                                        on:click={() => cancelRequest(user)}>Cancel
                                        Request</a>
                                {:else}
                                    <a
                                        class="MatchOptionsMobile btn btn-grey"
                                        style="margin-top:-4px;"
                                        href="#"
                                        data={selectedRoleType == "P" ? selectedRoleType + user.bulkProcessPupilID : selectedRoleType == "S" ? selectedRoleType + user.bulkProcessStaffID : 0}
                                        data-toggle="modal"
                                        data-target=".match-options"
                                        on:click={() => showMatchOptions(user)}>Match
                                        Options</a>
                                {/if}
                                {#if user.request && user.request != ''}
                                    <span
                                        class="info fas fa-info-circle"
                                        tabindex="0" />
                                    <div
                                        class="mt-2 tooltip_text">
                                        <span>{user.request}</span>
                                    </div>
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </DataTable>
        </div>
    </div>
 

{#if showModal}
    <MatchUsers 
        bind:showModal={showModal} 
        bind:showConfirmModal={showConfirmModal} 
        bind:isButtonLoading={isButtonLoading}
        bind:isMatchButtonLoading={isMatchLoading}
        bind:isPageLoading={isPageLoading}
        on:confirm={handleConfirm}
        on:create={createNewUser}
        {selectedUser} 
        {role} 
        {matchedUsers}
    />
{/if}

<Modal
    showModal={showResultModal}
    on:close={() => (resultMessage = '')}
    sizeClass="modal-lg">
    <div slot="header">
    <h4 class="title"><span class='info fas fa-info-circle'/> {resultModalHeading}</h4>
    </div>
    <div slot="content">
        {@html resultMessage}
    </div>
</Modal>
<!-- 
<ModalConfirm
    bind:showModal={showConfirmModal}
    zindex="1052"
    sizeClass="modal-lg"
    headerText={confirmModalHeader}
    targetClass="confirm-options"
    on:confirm={onHandleConfirm}>
    <div slot="content">
        {@html confirmMessage}
    </div>
</ModalConfirm> -->
